import{
    scpEmvProfileConstants,
    nameSpace
} from  "../constants/scpEmvProfileCode.constants";

const initialState={
    loading: false,
    success: false,
    request: null,
    response: null,
    error: null 
};

export const getAllScpEmvProfileCode= (state = initialState, action) => {
    switch (action.type) {
      case  scpEmvProfileConstants[`GET_${nameSpace}_REQUEST`]:
        return {
          ...state,
          loading: true,
          request: action.request,
          response: null
        };
      case  scpEmvProfileConstants[`GET_${nameSpace}_SUCCESS`]:
        return {
          ...state,
          loading: false,
          success: true,
          response: action.response,
          error: null
        };
      case  scpEmvProfileConstants[`GET_${nameSpace}_FAILURE`]:
        return {
          ...state,
          loading: false,
          success: false,
          response: null,
          error: action.error
        };
      case  scpEmvProfileConstants[`GET_${nameSpace}_RESET`]:
        return {
          ...state,
          ...initialState
        };
      default:
        return state;
    }
  };